module.exports = __webpack_public_path__ + "img/pointer-active.836c1400.png";